@if (externArbetsorderDetails) {
  <rask-page
    pageTitle="Externarbetsorder detaljer"
    noPadding
    [footerShow]="true">
    <ng-container headerContent>
      <div class="row">
        <rask-input class="col-1" label="Avtalsobjekt" [ngModel]="externArbetsorderDetails.avtalsobjekt" [readonly]="true"></rask-input>
        <rask-input class="col-2" label="Namn" [ngModel]="externArbetsorderDetails.arbetsorderNamn" [readonly]="true"></rask-input>
        <rask-input class="col-2" label="Uppdragsgivare" [class.input-italic]="!externArbetsorderDetails.ckLeverantorKod" [ngModel]="externArbetsorderDetails.uppdragsgivare" [readonly]="true"></rask-input>
        <rask-selector
          class="col-2"
          label="Transportforetag"
          [viewFormatter]="formatter"
          [formatter]="outputFormatter"
          (ngModelChange)="transportforetagChanged($event)"
          [(ngModel)]="externArbetsorderDetails.transportforetagId"
          [values]="transportforetagList">
        </rask-selector>
        <div class="col-2 header-status-icon">
          <rask-label size="12">Status</rask-label>
          <rask-icon [text]="externArbetsorderDetails.felmeddelande" [icon]="getIcon(externArbetsorderDetails)"></rask-icon>
        </div>
      </div>
    </ng-container>
    <div class="row">
      <rask-list class="footer-padding" [data]="externArbetsorderDetails.destineringsrader" [virtualScroll]="true" virtualScrollType="window" [virtualScrollItemHeight]="36" [fixedHeader]="true">
        <rask-list-column header="Inmätt handelssortiment" field="inmatningshandelssortiment" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Producerat handelssortiment" field="produceratHandelssortiment" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Handelssortiment" field="handelssortiment" width="10%" [sortable]="true">
        </rask-list-column>
        <rask-list-column header="Mottagningsplats" field="mottagningsplats" width="10%" [sortable]="true"></rask-list-column>
        <rask-list-column header="Giltig fr.o.m" field="giltigFrom" width="10%" [sortable]="true">
          <ng-template let-value>
            {{value | date:'yyyy-MM-dd'}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Giltig t.o.m" field="giltigTom" width="10%" [sortable]="true">
          <ng-template let-value>
            {{value | date:'yyyy-MM-dd'}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Ignorera" width="5%">
          <ng-template let-row="row">
            <rask-checkbox class="row-checkbox" [(ngModel)]="row.checked" [disabled]="disableIgnorera(row)" (checkedChange)="toggleStatus($event, row)"></rask-checkbox>
          </ng-template>
        </rask-list-column>
        <rask-list-column width="20%">
          <ng-template let-row="row">
            <rask-icon [text]="row.felmeddelande" [icon]="getIconRow(row)"></rask-icon>
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
    <ng-container footerContent>
      <div #footer>
        <rask-arbetsorder-viol3-button [arbetsorder]="externArbetsorderDetails" [isFormDirty]="false"></rask-arbetsorder-viol3-button>
        <rask-save-button [disabled]="!canSave()" (click)="save()"></rask-save-button>
        <rask-button [disabled]="!canUpdate()" (click)="update()">Kör om regelverk</rask-button>
      </div>
    </ng-container>
  </rask-page>
}
